"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compileRules;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _invariant = _interopRequireDefault(require("invariant"));

var _isArray = _interopRequireDefault(require("lodash/fp/isArray"));

var _isNumber = _interopRequireDefault(require("lodash/fp/isNumber"));

var _isString = _interopRequireDefault(require("lodash/fp/isString"));

var _pipeP = _interopRequireDefault(require("./utils/pipeP"));

var _compileCleanRules = _interopRequireDefault(require("./compileCleanRules"));

var _compileGroupBySuperGroup = _interopRequireDefault(require("./compileGroupBySuperGroup"));

/**
 *
 * @param {Object} [options]
 * @param {string | number} [options.validTreshold] Ezpressed in seconds or string describing a time span [`zeit/ms`](https://github.com/zeit/ms).
 *
 */
function compileRules(_x, _x2) {
  return _compileRules.apply(this, arguments);
}

function _compileRules() {
  _compileRules = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(options, rules) {
    var _ref, _ref$validTreshold, validTreshold;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = options || {}, _ref$validTreshold = _ref.validTreshold, validTreshold = _ref$validTreshold === void 0 ? '1d' : _ref$validTreshold;
            (0, _invariant.default)((0, _isString.default)(validTreshold) || (0, _isNumber.default)(validTreshold), 'compileRules() requires option `validTreshold` to be an `string` or `number`.');
            (0, _invariant.default)((0, _isArray.default)(rules), 'compileRules() requires `rules` param to be an `Array`.');
            return _context.abrupt("return", (0, _pipeP.default)((0, _compileCleanRules.default)({
              validTreshold: validTreshold
            }), (0, _compileGroupBySuperGroup.default)())(rules));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _compileRules.apply(this, arguments);
}